import { render } from "./aio-login-temp-access.vue?vue&type=template&id=f37c557a"
import script from "./aio-login-temp-access.vue?vue&type=script&lang=js"
export * from "./aio-login-temp-access.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__